import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { DEFAULT_COLUMNS_URL } from '../../actions/defaultColumns';
import { logRavenException } from '../../utils/ravenWrapperUtil';
const OVERRIDE_REP_DEAL_COLUMNS_URL = 'forecasting/v1/settings/rep-deal-column/override/';
const SYSTEM_DEFAULT_COLUMNS_URL = `${DEFAULT_COLUMNS_URL}/get-system-default`;
export const DEFAULT_COLUMNS_FIELD_NAME = 'defaultColumns';
export const getSystemDefaultColumns = amountProperty => {
  return http.get(SYSTEM_DEFAULT_COLUMNS_URL, {
    query: {
      propertiesToInclude: amountProperty
    }
  }).catch(error => {
    logRavenException(error, 'Get system default columns', {
      amountProperty
    });
    return null;
  });
};
export const getDefaultColumns = forecastTypeId => {
  return http.get(`${DEFAULT_COLUMNS_URL}/${forecastTypeId}`).catch(error => {
    logRavenException(error, 'Get default columns', {
      forecastTypeId
    });
    return null;
  });
};
export const GET_DEFAULT_COLUMNS = registerQuery({
  fieldName: DEFAULT_COLUMNS_FIELD_NAME,
  args: ['forecastTypeId', 'amountProperty'],
  async fetcher(data) {
    if (data.forecastTypeId === null) {
      const response = await getSystemDefaultColumns(data.amountProperty);
      return response === null || response === void 0 ? void 0 : response.dealColumns;
    }
    const response = await getDefaultColumns(data.forecastTypeId);
    return response === null || response === void 0 ? void 0 : response.dealColumns;
  }
});
export const UPDATE_REP_DEAL_COLUMNS = registerQuery({
  fieldName: 'overrideRepDealColumns',
  args: ['forecastTypeId', 'isDryRun'],
  async fetcher({
    forecastTypeId,
    isDryRun
  }) {
    const response = await http.put(`${OVERRIDE_REP_DEAL_COLUMNS_URL}/${forecastTypeId}`, {
      query: {
        dryRun: isDryRun
      }
    });
    return response;
  }
});